import {PerformanceReviewPage as PerformanceReviewFeaturePage} from '@features/performance-review'
import {PermissionType} from '@hconnect/apiclient'
import {PageTitle} from '@hconnect/uikit/src/lib2'
import {Stack} from '@mui/material'
import {useEffect} from 'react'
import {useTranslation} from 'react-i18next'
import {useParams} from 'react-router'

import {
  PerformanceReviewPageEventName,
  useTrackPerformanceReviewPageAnalyticsEvent
} from '../../performanceDashboard/helpers'
import {useTranslationPrefix} from '../../shared/hooks'
import {PlantSelectBreadcrumb} from '../components'

type TitleProps = {
  title: React.ReactNode
  breadcrumbs?: React.ReactNode
}

const Title = ({title, breadcrumbs}: TitleProps) => {
  return (
    <Stack>
      {breadcrumbs}
      <PageTitle ml={0}>{title}</PageTitle>
    </Stack>
  )
}

type PathParameter = {
  plantId: string
}

type Props = {
  permission: PermissionType
}

export const PerformanceReviewPage = ({permission}: Props) => {
  const {plantId} = useParams<PathParameter>()
  if (!plantId) throw new Error('plantId is missing')

  const {t} = useTranslation()
  const {hrocPrefix} = useTranslationPrefix()

  const trackPerformanceReviewPage = useTrackPerformanceReviewPageAnalyticsEvent()
  useEffect(() => {
    trackPerformanceReviewPage(PerformanceReviewPageEventName.UserEntersPerformanceReviewPage, {})
  }, [trackPerformanceReviewPage])

  return (
    <PerformanceReviewFeaturePage
      plantId={plantId}
      inverted
      titleSlot={
        <Title
          title={t(`${hrocPrefix}.performanceReview.pageTitle`)}
          breadcrumbs={<PlantSelectBreadcrumb permission={permission} sx={{ml: 0}} />}
        />
      }
    />
  )
}
